export default {
    blueprint :  [
        {
          label: "Icon Bullet",
          key: ["icon"],
          type: "icon-picker"
        }
      ]
  }
  